// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#panel-header {
  position: var(--boxx-header-position, relative);
  height: 57px;
}

#oval-ornament {
  background: var(--boxx-ornament-background, var(--ion-color-primary));
  width: var(--boxx-ornament-width, 120%);
  margin-left: var(--boxx-ornament-margin-left, -10%);
  position: var(--boxx-ornament-position, absolute);
  border-bottom-left-radius: var(--boxx-ornament-border-bottom-left-radius, 50% 50%);
  border-bottom: var(--boxx-ornament-border-bottom, 6px solid var(--ion-color-tertiary));
  border-right: var(--boxx-ornament-border-right, 6px solid var(--ion-color-tertiary));
  border-bottom-left-radius: 0px;
  border-bottom-right-radius: 0px;
  height: 100%;
}

@media (min-width: 960px) {
  #panel-header {
    position: var(--boxx-header-position, relative);
    height: 64px;
    display: none;
  }
  #oval-ornament {
    border-bottom-left-radius: 0px;
    border-bottom-right-radius: 0px;
    border-left: 0px;
    height: 100%;
  }
}
.bg-GETNET {
  background: #ad1324 !important;
}

.bg-BOXX {
  background: #0554F2 !important;
}

.bg-TODOSW {
  background: #111743 !important;
  border-bottom: var(--boxx-ornament-border-bottom, 0px solid) !important;
}`, "",{"version":3,"sources":["webpack://./src/modules/@boxx/panel-core/lib/components/main-heder/main-header.component.scss"],"names":[],"mappings":"AAAA;EACE,+CAAA;EAEA,YAAA;AAAF;;AAGA;EACE,qEAAA;EACA,uCAAA;EAEA,mDAAA;EACA,iDAAA;EACA,kFAAA;EAYA,sFAAA;EAIA,oFAAA;EAKA,8BAAA;EACA,+BAAA;EACA,YAAA;AAnBF;;AAwBA;EACE;IACE,+CAAA;IAEA,YAAA;IACA,aAAA;EAtBF;EAyBA;IACE,8BAAA;IACA,+BAAA;IACA,gBAAA;IACA,YAAA;EAvBF;AACF;AA0BA;EACE,8BAAA;AAxBF;;AA2BA;EACE,8BAAA;AAxBF;;AA2BA;EACE,8BAAA;EACA,uEAAA;AAxBF","sourcesContent":["#panel-header {\n  position: var(--boxx-header-position, relative);\n  //height: var(--boxx-header-height, 160px);\n  height: 57px;\n}\n\n#oval-ornament {\n  background: var(--boxx-ornament-background, var(--ion-color-primary));\n  width: var(--boxx-ornament-width, 120%);\n  //height: var(--boxx-ornament-height, 100%);\n  margin-left: var(--boxx-ornament-margin-left, -10%);\n  position: var(--boxx-ornament-position, absolute);\n  border-bottom-left-radius: var(\n    --boxx-ornament-border-bottom-left-radius,\n    50% 50%\n  );\n  // border-bottom-right-radius: var(\n  //   --boxx-ornament-border-bottom-right-radius,\n  //   50% 50%\n  // );\n  // border-left: var(\n  //   --boxx-ornament-border-left,\n  //   6px solid var(--ion-color-tertiary)\n  // );\n  border-bottom: var(\n    --boxx-ornament-border-bottom,\n    6px solid var(--ion-color-tertiary)\n  );\n  border-right: var(\n    --boxx-ornament-border-right,\n    6px solid var(--ion-color-tertiary)\n  );\n\n  border-bottom-left-radius: 0px;\n  border-bottom-right-radius: 0px;\n  height: 100%;\n}\n\n\n//PWA\n@media (min-width: 960px) {\n  #panel-header {\n    position: var(--boxx-header-position, relative);\n    //height: var(--boxx-header-height, 79px);\n    height: 64px;\n    display: none;\n  }\n\n  #oval-ornament {\n    border-bottom-left-radius: 0px;\n    border-bottom-right-radius: 0px;\n    border-left: 0px;\n    height: 100%;\n  }\n}\n\n.bg-GETNET{\n  background: #ad1324 !important;\n}\n\n.bg-BOXX{\n  background: #0554F2 !important;\n}\n\n.bg-TODOSW{\n  background: #111743 !important;\n  border-bottom: var(--boxx-ornament-border-bottom, 0px solid) !important;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
